export const dashboard = '/dashboard';
export const chat = '/chat';
export const settings = '/settings';
export const logout = '/logout';
export const login = '/login';
export const register = '/register';
export const archive = '/archive';
export const users = '/users';
